import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/platform/')({
  beforeLoad: () => {
    throw redirect({ to: '/sysadmin/platform/deployment' });
  },
});
